export default "__VITE_ASSET__7k3MzgAy__"